import { render, staticRenderFns } from "./CmdController.vue?vue&type=template&id=5c80dc54&"
import script from "./CmdController.ts?vue&type=script&lang=ts&"
export * from "./CmdController.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports